
define('text!static/not-found.html',[],function () { return '<div class="not-found">\r\n    <div class="content-header">\r\n        <div class="container">\r\n            <h1>Page not found</h1>\r\n        </div>\r\n    </div>\r\n</div>';});

